<template>
  <div id="qhkh">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="logo"></div>
      </div>
    </header>
    <div class="down-wrapper">
      <div class="dhqh"></div>
      <div class="title">东航期货APP</div>
      <!--TODO 链接地址-->
      <a>点击下载</a>
    </div>
    <div class="text">
      东航金融App 由央企东航集团旗下金融机构东航金融联合东航期货、东航国际金融（香港）等共同研发，以期货投资为特色，涵盖私募资管等业务。功能包括手机开户、行情交易、交易策略、数据分析、私募基金、组合配置、各类计算等。是业内领先的智能金融移动工具。

    </div>
    <div class="down-wrapper">
      <div class="qhykh"></div>
      <div class="title">期货开户云APP</div>
      <!--TODO 链接地址-->
      <a>点击下载</a>
    </div>
    <div class="text">
      <p>期货互联网开户云APP是中国期货市场监控中心通过云技术，为期货公司提供免费的互联网开户业务。</p>
      <p>投资者可使用该APP办理期货网上开户业务，目前支持大连商品交易所，郑州商品交易所，上海期货交易所和中国金融期货交易所的自然人客户（限中国大陆居民）开户功能。</p>
    </div>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'

  export default {
    name: 'qhkh',
    components: {
      OffCanvas,
      ICP
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"

  #qhkh
    .logo-wrapper
      display: inline-block
      padding-top 13px
      .logo
        margin auto
        bg-image('logo', 70px, 18px)
        vertical-align inherit
    .down-wrapper
      background-color #e8edf7
      height 90px
      padding 0 $bj 0 $bj
      .dhqh
        display inline
        margin-top 17px
        bg-image('东航金融', 56px, 56px)
      .qhykh
        display inline
        margin-top 17px
        bg-image('期货云', 56px, 56px)
      .title
        display inline
        color $font_color1
        font-weight bold
        font-size $font_size1
        height 90px
        line-height 90px
        margin-left 10px
      a
        float right
        height 35px
        margin-top 27.5px
        width 110px
        background-color $color1
        border-radius 5px
        color #fff
        border 0
        font-size 14px
        text-align center
        line-height 35px
        font-weight bolder
    .text
      padding 17px $bj 0 $bj
      margin-bottom 50px
      text-indent: 2em;
</style>



// WEBPACK FOOTER //
// qhkh.vue?036a000e